/**
         * 系统配置
         * objectAdmin 对象管理
         * WebhookAdmin webhook 管理

          *
          * 注意***
          *   只有管理员才可见用户管理页面
          */
const _path = '/system/'

const SystemRouter: any = {
  meta: {
    title: '系统配置',
    icon: 'el-icon-warning-outline'
  },
  children: [
    {
      path: _path + 'user',
      component: () => import('@/views/SystemAdmin/UserAdmin/index.vue'),
      meta: {
        title: '用户管理',
        hidden: false,
        auth: true
      }
    },
    {
      path: _path + 'objectAdmin',
      component: () => import('@/views/SystemAdmin/ObjectAdmin/index.vue'),
      meta: {
        title: '对象管理',
        hidden: false
      }
    },
    {
      path: _path + 'add',
      component: () => import('@/views/SystemAdmin/AddObject/index.vue'),
      meta: {
        title: '新增对象',
        parentPath: _path + 'objectAdmin',
        hidden: true
      }
    },
    {
      path: _path + 'webhookAdmin',
      component: () => import('@/views/SystemAdmin/WebhookAdmin/index.vue'),
      meta: {
        title: 'Webhook管理',
        hidden: false
      }
    }
  ]
}

export default SystemRouter
